import { AssignmentQuestionTypesEnum } from '@school_ify/schoolify-repository/src/shared/types';

/* eslint-disable import/prefer-default-export */
export const QuizQuestionsNamesForType = {
  PICK_OPTIONS: 'Pick one or more options',
  FILL_IN_BLANK: 'Fill in a blank form',
  OPEN_QUESTION: 'Open question',
  MATCHING: 'Matching',
};

export const questionTypeOptions = [
  {
    id: '1',
    name: 'Pick one or more options',
    alias: 'one or more options',
    path: '/quiz/multiple-option',
    imagePath: '/assets/icons/pick-one-or-more.svg',
    type: AssignmentQuestionTypesEnum.PICK_OPTIONS,
  },
  {
    id: '2',
    name: 'Fill in a blank form',
    alias: 'blank form',
    path: '/quiz/blank-form',
    imagePath: '/assets/icons/fill-in-blank.svg',
    type: AssignmentQuestionTypesEnum.FILL_IN_BLANK,
  },
  {
    id: '3',
    name: 'Matching',
    alias: 'matching',
    path: '/quiz/matching',
    imagePath: '/assets/icons/matching.svg',
    type: AssignmentQuestionTypesEnum.MATCHING,
  },
  {
    id: '4',
    name: 'Open question',
    alias: 'open question',
    path: '/quiz/open-question',
    imagePath: '/assets/icons/open-question.svg',
    type: AssignmentQuestionTypesEnum.OPEN_QUESTION,
  },
];
